<template>
  <div class="user_container">
    <div class="container">
      <img src="@/assets/car/evaluate/bg.svg" alt="" class="img1" />
      <img
        src="@/assets/car/evaluate/dele.svg"
        alt=""
        class="img2"
        @click="toUrl"
      />
      <div class="title">雷士用车评价</div>
      <div class="box">
        <div class="rate">
          <van-rate
            v-model="valueRate"
            :size="35"
            color="#ffd21e"
            void-icon="star"
            void-color="#eee"
            :readonly="flag == 1 ? false : true"
          />
        </div>
        <div class="rate_value">
          <div v-if="valueRate == '1'">非常不满意，各方面都很差</div>
          <div v-if="valueRate == '2'">不满意，有待提高</div>
          <div v-if="valueRate == '3'">一般，服务态度一般</div>
          <div v-if="valueRate == '4'">比较满意，仍可改善</div>
          <div v-if="valueRate == '5'">非常满意，无可挑剔</div>
        </div>
        <div class="checkbox">
          <el-checkbox-group
            v-model="checkboxGroup"
            :disabled="flag == 1 ? false : true"
          >
            <el-checkbox-button label="驾车娴熟平稳" style="margin-right: 15px"
              >驾车娴熟平稳</el-checkbox-button
            >
            <el-checkbox-button label="准时送达目的地"
              >准时送达目的地</el-checkbox-button
            >
            <el-checkbox-button label="服务态度好" style="margin-right: 15px"
              >服务态度好</el-checkbox-button
            >
            <el-checkbox-button label="活地图 认路准"
              >活地图 认路准</el-checkbox-button
            >
            <el-checkbox-button label="打电话玩手机" style="margin-right: 15px"
              >打电话玩手机</el-checkbox-button
            >
            <el-checkbox-button label="服务态度恶劣"
              >服务态度恶劣</el-checkbox-button
            >
          </el-checkbox-group>
        </div>
        <div class="field" v-if="flag == '1'">
          <van-field
            v-model="message"
            rows="2"
            :autosize="{ maxHeight: 40 }"
            type="textarea"
            placeholder="其他想说（将匿名告知司机）"
          />
        </div>
        <div class="field_text" v-if="flag == '2'">
          <div>{{ message ? message : "暂无评价" }}</div>
        </div>
        <div class="button" v-if="flag == '1'">
          <van-button @click="submit">匿名提交</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import api from "@/apis";
import apiCar from "@/apis/car";

// import { getToken, setToken } from "@/utils/cookie";
export default {
  name: "detail",
  props: {},
  components: {},
  data() {
    return {
      valueRate: 0,
      checkboxGroup: [],
      message: "",
      flag: "1",
      applyNumber:''
    };
  },
  created() {},
  mounted() {
    this.applyNumber = this.$route.query.applyNumber
    this.getList()
    // let token = getToken();
    // if (token) {
    //   this.getUserToken(token);
    // } else {
    //   this.$bus.$on("processToken", (res) => {
    //     this.getUserToken(res);
    //   });
    // }
  },
  methods: {
    //获取评价信息
    getList() {
      apiCar.queryComment({ applyNumber: this.applyNumber }).then((data) => {
        if (data.code == 200) {
          const res = data.data;
          if (res.length > 0) {
            this.flag = "2";
            this.message = res[0].remarks;
            this.valueRate = res[0].score;
            this.checkboxGroup = res[0].label.split(",");
          } else {
            this.flag = "1";
          }
        }
      });
    },
    // getUserToken(empNo) {
    //   if (empNo) {
    //     let thisname = empNo;
    //     api.queryByUsername({ username: thisname }).then((data) => {
    //       const info = data.data;
    //       console.log(info, "info");
    //       setToken(empNo);
    //       this.getList();
    //       // this.$store.commit("changeUserInfo", info);
    //     });
    //   }
    // },
    //提交
    submit() {
      const json = {
        applyNumber: this.applyNumber,
        score: this.valueRate,
        label: this.checkboxGroup.join(","),
        remarks: this.message,
      };
      console.log(json, "json");

      if (this.valueRate == 0) {
        return this.$message({
          type: "error", // success error warning
          message: "请选择评分",
          duration: 2000,
        });
      }

      if (this.checkboxGroup.length < 1) {
        return this.$message({
          type: "error", // success error warning
          message: "请选择评价标签",
          duration: 2000,
        });
      }

      apiCar.addOrUpdate(json).then((data) => {
        if (data.code == 200) {
          this.$message({
            type: "success", // success error warning
            message: "评论成功",
            duration: 2000,
          });
          this.getList()
          this.toUrl();
        }
      });
    },
    //返回上一页
    toUrl() {
      // this.$router.go(-1);
      window.close(); 
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}
.user_container {
  min-height: 100vh;
  //   padding: 30px;
  margin: auto;
  font-size: 1vh;
  font-size: 26px;
  background: rgba(0, 0, 0, 0.6);
  //   position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  .container {
    width: 100%;
    height: 100%;
    position: relative;
    margin-bottom: -5px;
    .img1 {
      width: 100%;
      height: 100%;
    }
    .img2 {
      position: absolute;
      right: 30px;
      top: 0;
      width: 50px;
      height: 50px;
    }
    .title {
      position: absolute;
      top: 15.5%;
      left: 30px;
      font-size: 48px;
      font-weight: bold;
      color: rgba(40, 43, 50, 1);
    }
    .box {
      background: #fff;
      width: 100%;
      height: 76%;
      border-radius: 20px 20px 0 0;
      font-size: 32px;
      position: absolute;
      bottom: 0;
      left: 0;
      overflow: auto;
      padding-bottom: 40px;
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      .rate_value {
        text-align: center;
        margin-top: 30px;
        font-size: 30px;
        color: rgba(78, 162, 124, 1);
      }
      .field_text {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 25%;
        div {
          width: 85%;
          background: rgba(247, 249, 250, 1);
          color: #000;
          font-size: 30px;
          height: 100%;
          border-radius: 10px;
          padding: 20px;
        }
      }
    }
  }
}

::v-deep {
  .van-rate {
    margin-top: 45px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    div {
      margin-right: 40px;
    }
  }
  .el-checkbox-group {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 40px;
  }
  .el-checkbox-button {
    width: 40%;
    .el-checkbox-button__inner {
      // margin-right: 20px;
      margin-bottom: 40px;
      width: 100%;
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 26px;
      color: #000;
      border: 1px solid rgba(219, 218, 218, 1);
      border-radius: 10px;
    }
  }

  .is-checked {
    .el-checkbox-button__inner {
      background: rgba(78, 162, 124, 0.1) !important;
      color: rgba(51, 143, 108, 1) !important;
      border: 1px solid rgba(78, 162, 124, 0.1) !important;
      box-shadow: none;
      border-radius: 10px;
    }
  }

  .field {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    .van-field {
      width: 85%;
      border: 1px solid rgba(219, 218, 218, 1);
      border-radius: 10px;
    }
  }

  .button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    .van-button {
      width: 85%;
      border: 1px solid rgba(219, 218, 218, 1);
      border-radius: 10px;
      background: rgba(78, 162, 124, 1);
      color: #fff;
      margin-top: 30px;
      height: 90px;
      font-size: 28px;
    }
  }
}
</style>
